import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex mt-6 mb:mt-10 justify-center" }
const _hoisted_2 = { class: "flex-1 max-w-[812px] bg-white rounded-[20px] pt-[30px]" }
const _hoisted_3 = { class: "flex items-center justify-center mb-6 md:mb-10 relative" }
const _hoisted_4 = { class: "sf-pro font-semibold text-xl max-md:leading-[24px] md:text-2xl max-md:pl-4" }
const _hoisted_5 = { class: "rounded-[20px] overflow-y-auto" }
const _hoisted_6 = { class: "w-full text-left overflow-hidden" }
const _hoisted_7 = { class: "bg-brown max-md:hidden px-10" }
const _hoisted_8 = { class: "th-item pl-10" }
const _hoisted_9 = { class: "th-item" }
const _hoisted_10 = { class: "px-10" }

import { useI18n } from "vue-i18n";
import router from "@/router";
import { useUserStore } from "@/stores/userStore";
import OutlineButton from "@/components/buttons/OutlineButton.vue";
import { ROUTE_NAMES } from "@/constants/routeNames";


export default /*@__PURE__*/_defineComponent({
  __name: 'DestinyMatrixPurchadesDatesTable',
  setup(__props) {

const { t } = useI18n();
const userStore = useUserStore();

function showPurchasedMatrix(matrixDate: string) {
  router.push({
    name: ROUTE_NAMES.DESTINY_MATRIX,
    query: { init_date: matrixDate },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("destiny-matrix-purchased-dates-table.title")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", _hoisted_7, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)("destiny-matrix-purchased-dates-table.date")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(t)("destiny-matrix-purchased-dates-table.actions")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).user.products['destiny_matrix'], (matrixDate) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: matrixDate,
                class: "h-20 border-b border-ternary last:border-b-0"
              }, [
                _createElementVNode("td", _hoisted_10, _toDisplayString(matrixDate), 1),
                _createElementVNode("td", null, [
                  _createVNode(OutlineButton, {
                    class: "px-4 py-2",
                    isLoading: false,
                    "btn-text": _unref(t)('destiny-matrix-purchased-dates-table.show-btn'),
                    onClick: ($event: any) => (showPurchasedMatrix(matrixDate))
                  }, null, 8, ["btn-text", "onClick"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})